var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rowError)?_c('BTooltip',{attrs:{"target":_vm.rowError.target,"placement":"bottom","custom-class":"handsontable-error-tooltip"}},[_c('p',[_vm._v(_vm._s(_vm.$t('Fehler')))]),_c('p',[_vm._v(_vm._s(_vm.rowError.errorUserMessage))]),_c('FontAwesomeIcon',{attrs:{"icon":"exclamation-square"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }